"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.domSafe = function () {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};

var sendTracking = function sendTracking(values) {
  // For pushing data directly to the dataLayer
  if (exports.domSafe()) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(values);
  }
};

exports.eecAdd = function (products, list) {
  sendTracking({
    event: 'eec.add',
    ecommerce: {
      add: {
        actionField: {
          list: list
        },
        products: products
      }
    }
  });
};

exports.eecRemove = function (products, list) {
  sendTracking({
    event: 'eec.remove',
    ecommerce: {
      remove: {
        actionField: {
          list: list
        },
        products: products
      }
    }
  });
};

exports.eecPurchase = function (products, purchaseDetails) {
  sendTracking({
    event: 'eec.purchase',
    ecommerce: {
      purchase: {
        actionField: purchaseDetails,
        products: products
      }
    }
  });
};

exports.eecDetail = function (products, list) {
  sendTracking({
    event: 'eec.detail',
    ecommerce: {
      detail: {
        actionField: {
          list: list
        },
        products: products
      }
    }
  });
};

exports.eecCheckoutStep = function (products, step, option) {
  sendTracking({
    event: 'eec.checkout',
    ecommerce: {
      checkout: {
        actionField: {
          step: step,
          option: option
        },
        products: products
      }
    }
  });
};

exports.eecPromotionView = function (promotions) {
  sendTracking({
    event: 'eec.promotionView',
    ecommerce: {
      promoView: {
        promotions: promotions
      }
    }
  });
};

exports.eecPromotionClick = function (promotions) {
  sendTracking({
    event: 'eec.promotionClick',
    ecommerce: {
      promoClick: {
        promotions: promotions
      }
    }
  });
};

exports.eecImpressionView = function (impressions) {
  sendTracking({
    event: 'eec.impressionView',
    ecommerce: {
      impressions: impressions
    }
  });
};

exports.eecImpressionClick = function (impressions, list) {
  sendTracking({
    event: 'eec.impressionClick',
    ecommerce: {
      click: {
        actionField: {
          list: list
        },
        products: impressions
      }
    }
  });
};

exports.default = {
  eecPurchase: exports.eecPurchase,
  eecAdd: exports.eecAdd,
  eecRemove: exports.eecRemove,
  eecDetail: exports.eecDetail,
  eecCheckoutStep: exports.eecCheckoutStep,
  eecPromotionView: exports.eecPromotionView,
  eecPromotionClick: exports.eecPromotionClick,
  eecImpressionView: exports.eecImpressionView,
  eecImpressionClick: exports.eecImpressionClick
};